import Vue from 'vue'
import VueRouter from 'vue-router'

import BaseRoutes from '@/router/base'
import ContentRoutes from '@/router/content'
import SeniorRoutes from '@/router/senior'
import AdminRoutes from '@/router/admin'
import MemberRoutes from '@/router/member'
import OperationRoutes from '@/router/operation'
import ApplicationRoutes from '@/router/application'
import setting from '@/router/setting'

import Adjust from '@/router/adjust'
import Rank from '@/router/rank'
import Distribution from '@/router/distribution'
import QueryPart from '@/router/query'
import Select from '@/router/select'
import News from '@/router/news'


Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/dashboard'
    },
    {
      path: '/',
      component: () => import('../components/common/Home.vue'),
      children: [
        {
          path: '/dashboard',
          component: () => import('../pages/dashboard.vue'),
          meta: { title: '总览' }
        },

        // 基础数据部分
        ...BaseRoutes,

        // 内容管理部分
        ...ContentRoutes,

        // 应用管理
        ...ApplicationRoutes,

        // 学长管理部分
        ...SeniorRoutes,

        // 权限管理部分
        ...AdminRoutes,

        // 用户管理部分
        ...MemberRoutes,

        // 运营管理部分
        ...OperationRoutes,

        // 设置部分
        ...setting,

        // 调剂相关
        ...Adjust,

        // 查排名部分
        ...Rank,

        // 分销
        ...Distribution,

        // 查询系统
        ...QueryPart,

        // 选题
        ...Select,

        // 情报
        ...News,
        {
          path: '/404',
          component: () => import('../pages/404.vue'),
          meta: { title: '404' }
        }
      ]
    },
    {
      path: '/login',
      component: () => import('../pages/login.vue'),
      meta: { title: '登录' }
    },
    {
      path: '*',
      redirect: '/404'
    }
  ],
  // 页面滚动到项部
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
